export enum CREDIT_LIMIT_REQUEST_STATUSES {
  PENDING = "NEW",
  PARTIALLY_APPROVED = "PARTIALLY_APPROVED",
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
}

export type CreditLimitRequestStatusKey =
  keyof typeof CREDIT_LIMIT_REQUEST_STATUSES;
